import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { centerInfo } from '../utils/mockData';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/about', label: 'À Propos' },
    { path: '/courses', label: 'Cours' },
    { path: '/partners', label: 'Partenaires' },
    { path: '/gallery', label: 'Galerie' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-[#0039A6] to-[#007A5E] text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <div className="flex items-center gap-4">
              <a href={`tel:${centerInfo.phone}`} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                <Phone size={14} />
                <span>{centerInfo.phone}</span>
              </a>
              <a href={`mailto:${centerInfo.email}`} className="hidden sm:flex items-center gap-2 hover:opacity-80 transition-opacity">
                <Mail size={14} />
                <span>{centerInfo.email}</span>
              </a>
            </div>
            <div className="text-xs sm:text-sm">
              Lun-Ven: 08:00-17:30 | Sam: 09:00-15:00
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/4hauxdzl_WhatsApp%20Image%202026-01-08%20at%2022.14.16.jpeg" 
                alt="CLRC Logo" 
                className="h-14 w-14 object-contain"
              />
              <div className="flex flex-col">
                <span className="text-xl sm:text-2xl font-bold text-[#0039A6]">
                  Centre Linguistique Russe
                </span>
                <span className="text-xs sm:text-sm text-[#007A5E] font-medium">
                  du Cameroun
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-medium transition-colors relative group ${
                    isActive(link.path)
                      ? 'text-[#0039A6]'
                      : 'text-gray-700 hover:text-[#0039A6]'
                  }`}
                >
                  {link.label}
                  <span
                    className={`absolute bottom-0 left-0 w-full h-0.5 bg-[#D52B1E] transform transition-transform ${
                      isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  />
                </Link>
              ))}
              <Link
                to="/contact"
                className="bg-[#D52B1E] text-white px-6 py-2.5 rounded-md font-medium hover:bg-[#b82418] transition-all hover:shadow-lg transform hover:-translate-y-0.5"
              >
                Inscription
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-gray-700 hover:text-[#0039A6] transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="lg:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col gap-4">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`py-2 px-4 rounded-md transition-colors ${
                      isActive(link.path)
                        ? 'bg-[#0039A6] text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="bg-[#D52B1E] text-white py-2 px-4 rounded-md text-center hover:bg-[#b82418] transition-colors"
                >
                  Inscription
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};
